<template>

    <div>
        <div
            v-if="!updating"
        >
            <button
                class="btn btn-xs btn-default pull-right"
                @click="updating = true"
                v-tooltip="'Datum aanpassen'"
            >
                <i class="mdi mdi-pencil"></i>
                <span class="sr-only">Datum aanpassen</span>
            </button>
            {{ moment(value).format("DD-MM-YYYY") }}
        </div>
        <div
            v-else
            class="datepickerSection"
        >
            <date-picker
                v-model="dateValue"
                format="DD-MM-YYYY"
                lang="en"
            ></date-picker>
            <button type="button"
                @click="updateExpectedAt"
                class="btn btn-info btn-xs btn-flat"
            >
                <i class="mdi mdi-content-save"></i>
            </button>
        </div>
    </div>

</template>

<script>

import axios from 'axios';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';

export default {

    components: {
        DatePicker,
    },

    computed: {
        dateValue: {
            get() {
                return moment(this.value)._d;
            },
            set(newvalue) {
                newvalue = moment(newvalue).add(12, 'hour').format('YYYY-MM-DD');
                this.$emit('input', newvalue);
            },
        }
    },

    data() {
        return {
            moment:moment,
            updating:false,
        }
    },

    methods: {
        updateExpectedAt() {
            axios.patch(this.updateUrl, {expected_at: this.value})
            .then(() => {
                this.$snotify.success("De verwachtte datum is aangepast");
                this.updating = false;
            })
            .catch(() => this.$snotify.error("Er is een fout opgetreden bij het aanpassen van de datum"));
        },
    },

    name:"TasksUpdateExpected",

    props: {
        value: { required:true },
        updateUrl: { required:true },
    },

}

</script>

<style>

    .datepickerSection > .mx-datepicker {
        width:120px !important;
    }

</style>
